import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";




function ClientForm(props)
{


      const [checked1, setChecked1] = useState(false);
      const handleChange1= () => {
          setChecked1(!checked1);
      };  

    const [checked2, setChecked2] = useState(false);
      const handleChange2= () => {
          setChecked2(!checked2);
      };  

    const [services, setServices] = useState(null);
    const [accounts,  setAccounts] = useState(null);

    const [errTab, setErrTab] = useState([]); 
    const [row, setRow] = useState({

        id: -1,
        nazwa: '',
        imie_1: '',
        nazwisko_1: '',
        imie_2: '',
        nazwisko_2: '',

        zm_ulica: '',
        zm_nr_domu: '',
        zm_nr_mieszkania: '',
        zm_kod_pocztowy: '',
        zm_miejscowosc: '',
        kraj: '',

        kr_nazwa: '',
        kr_ulica: '',
        kr_nr_domu: '',
        kr_nr_mieszkania: '',
        kr_kod_pocztowy: '',
        kr_miejscowosc: '',
        kr_kraj: '',

        odbr_nazwa: '',        
        odbr_ulica: '',        
        odbr_nr_domu: '',        
        odbr_nr_mieszkania: '',        
        odbr_kod_pocztowy: '',        
        odbr_miejscowosc: '',        
        odbr_nip: '',        
        odbr_regon: '',        
        odbr_telefon: '',        

        telefon_kontaktowy: '',
        email_kontaktowy: '',
        osoba_kontaktowa: '',

        nip: '',
        regon: '',

        e_faktura: '0',
        e_mail_dla_faktur: '', 
        termin_platnosci: 14,

        services: [],
        rodzaj_kontrahenta: 'PL',  //PL EU 
        sl_rachunki_bankowe_id: '_x_',  //numer rachunku do wpłat


    });
    var tmpRow = row;


 


 



    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         


               

                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
                
                if(filedName == 'nip' && correct && props.id < 0)
                {
                  getByNIP(val, (firm) => {


                        if(firm['nazwa'] != undefined)
                        {
                              //dezaktywuj inputa.. by nie był aktywny..
                              Array.from(document.querySelectorAll('input')).forEach(el => el.blur())

                              props.mainView.showDialog("Pytanie" , "Czy chodzi Ci o firmę: " + firm["nazwa"]  ,  "yesno"  , ( resp) => {

                                if(resp == "yes")
                                {
                                        //-------------------------------------------------------------
                                        //-------------------------------------------------------------
                                    
                                                console.log(firm);

                                                tmpRow["nazwa"] = firm['nazwa'];
                                                tmpRow["nazwa_valid"] = true;   

                                                tmpRow["zm_ulica"] = firm['ulica'];
                                                tmpRow["zm_ulica_valid"] = true;
                                                
                                                tmpRow["zm_nr_domu"] = firm['nr_domu'];
                                                tmpRow["zm_nr_domu_valid"] = true;  

                                                tmpRow["zm_nr_mieszkania"] = firm['nr_mieszkania'];
                                                tmpRow["zm_nr_mieszkania_valid"] = true;

                                                tmpRow["zm_kod_pocztowy"] = firm['kod_pocztowy'];
                                                tmpRow["zm_kod_pocztowy_valid"] = true;

                                                tmpRow["zm_miejscowosc"] = firm['miejscowosc'];
                                                tmpRow["zm_miejscowosc_valid"] = true;

                                                tmpRow["zm_kraj"] = 'Polska';
                                                tmpRow["zm_kraj_valid"] = true;


                                                tmpRow["kr_ulica"] = firm['ulica'];
                                                tmpRow["kr_ulica_valid"] = true;
                                                
                                                tmpRow["kr_nr_domu"] = firm['nr_domu'];
                                                tmpRow["kr_nr_domu_valid"] = true;  

                                                tmpRow["kr_nr_mieszkania"] = firm['nr_mieszkania'];
                                                tmpRow["kr_nr_mieszkania_valid"] = true;

                                                tmpRow["kr_kod_pocztowy"] = firm['kod_pocztowy'];
                                                tmpRow["kr_kod_pocztowy_valid"] = true;

                                                tmpRow["kr_miejscowosc"] = firm['miejscowosc'];
                                                tmpRow["kr_miejscowosc_valid"] = true;

                                                tmpRow["kraj"] = 'Polska';
                                                tmpRow["kraj_valid"] = true;

                                                tmpRow["zm_kraj"] = 'Polska';
                                                tmpRow["zm_kraj_valid"] = true;

                                                tmpRow["kr_kraj"] = 'Polska';
                                                tmpRow["kr_kraj_valid"] = true;

                                                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    

                                        //-------------------------------------------------------------
                                        //-------------------------------------------------------------
                                }


                              } ); 
                        }

                        

                  });
                }

            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_home,client_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



    const getTServices = () => {
        
        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,t_services', {
            method: 'POST', 
            body: [], 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

               props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setServices(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }

    const getAccounts = () => {
        
        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,accounts', {
            method: 'POST', 
            body: { combo:true }, 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setAccounts(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const getClientDet = () => {
        
    
         props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,client_det', {
            method: 'POST', 
            body: JSON.stringify( { id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


     const getByNIP = (nip, onSuccess  ) => {
        
        
        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,nip', {
            method: 'POST', 
            body: JSON.stringify( { nip: nip }) , 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        onSuccess(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



     const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    
                        console.log("keylockd", e.target.nodeName, code );

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                                           
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else 
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                        } else 
                        {
                            props.keyListener(e);
                        }

     }


      useEffect(() => {
        
                             

                if(Config.env == "dev") console.log("ClientForm.js, listener on");
                window.onkeydown =  keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("ClientForm.js, listener off");      
                    window.onkeydown =  props.keyListener;
                };

      });
   

    


    if(services == null)
    {
        setServices([]);
        getTServices(); 
        return <div>...</div>
    }


    if(accounts == null)
    {
        setAccounts([]);
        getAccounts(); 
        return <div>...</div>
    }

    if(row.id == -1 && props.id > 0)
    {
        setRow( {...row, ["id"]:-2  } );  
        getClientDet();
    }


        if(row.nazwa.length > 1)
            {
              document.title = row.nazwa;
            }else  document.title = 'Dane klienta';


    return <div className="view_content">

                  

                       <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                       <div className="app_header">{row.nazwa}</div>
          
                       <form className="eForm bg_center">
                           

                                <div className="form_tab_title">Rodzaj dostarczanych usług:</div>
                                <div className="form_tab">
                                    
                                    {
                                        services.map( (item, ix) => {                                        

                                            var ccc = false;

                                            for(var p=0; p<row.services.length; p++)
                                            {
                                                if(row.services[p] == item.v)      ccc = true;
                                            }

                                                return (
                                                    <div className="form_control">                                                         
                                                        <InputChecbox  title={item.title}  err={errTab}  userData={props.userData}  checked={ccc} value={item.v} valChange={valChangeListener}  name={ "services@"+ix  }   className=' ' req='0' />
                                                    </div>
                                                )
                                        } )
                                    }

                                </div>


                                <div className="form_tab_title">Informacje podstawowe:</div>
                                <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP   userData={props.userData} value={row.nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP:"} className='  ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">REGON</div>
                                                <InputNIP   userData={props.userData} value={row.regon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="regon" placeholder={"REGON:"} className='  ' req='0' firstUp="1" />
                                            </div>
                                    
                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Fortis Auto"} className=' w300 ' req='1' firstUp="1" />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Osoba kontaktowa</div>
                                                <InputText   userData={props.userData} value={row.osoba_kontaktowa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="osoba_kontaktowa" placeholder={"Osoba kontaktowa:"} className=' w300 ' req='0' firstUp="0" />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">E-mail</div>
                                                <InputEmail   userData={props.userData} value={row.email_kontaktowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="email_kontaktowy" placeholder={"E-mail"} className='   ' req='0' firstUp="0" />
                                            </div>

                                            
                                            <div className="form_control">
                                                <div className="fieldName">Telefon</div>
                                                <InputPhone userData={props.userData} value={row.telefon_kontaktowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="telefon_kontaktowy" placeholder={"Telefon:"} className='  ' req='0' firstUp="0" />
                                            </div>


                                </div>


                                <div className="form_tab_title">Adres:</div>
                                <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText   userData={props.userData} value={row.zm_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zm_ulica" placeholder={"Ulica:"} className=' w300 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Nr domu*</div>
                                                <InputText   userData={props.userData} value={row.zm_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zm_nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='1' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Nr mieszkania</div>
                                                <InputText   userData={props.userData} value={row.zm_nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zm_nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_split"></div>

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy</div>
                                                <InputPostCode   userData={props.userData} value={row.zm_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zm_kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Miasto</div>
                                                <InputTextAlpha   userData={props.userData} value={row.zm_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zm_miejscowosc" placeholder={"Miasto:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Kraj</div>
                                                <InputTextAlpha   userData={props.userData} value={row.kraj} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kraj" placeholder={"Kraj:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>
                                </div>


                                <div className="form_tab_title">
                                    Adres do korespondencji (jeśli inny niż powyższy):
                                            &nbsp; 
                                            <label className="switch" title="Więcej">                               
                                                <input type="checkbox" checked={checked1}  onChange={handleChange1}/>
                                                <span className="slider round"></span>
                                            </label>  
                                </div>

                                {
                                    checked1 &&
                                        <div className="form_tab">

                                                    <div className="form_control">
                                                        <div className="fieldName">Ulica*</div>
                                                        <InputText   userData={props.userData} value={row.kr_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_ulica" placeholder={"Ulica:"} className=' w300 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nr domu*</div>
                                                        <InputText   userData={props.userData} value={row.kr_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nr mieszkania</div>
                                                        <InputText   userData={props.userData} value={row.kr_nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputPostCode   userData={props.userData} value={row.kr_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputTextAlpha   userData={props.userData} value={row.kr_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_miejscowosc" placeholder={"Miasto:"} className=' w200 ' req='0' firstUp="1" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Kraj</div>
                                                        <InputTextAlpha   userData={props.userData} value={row.kr_kraj} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_kraj" placeholder={"Kraj:"} className=' w200 ' req='0' firstUp="1" />
                                                    </div>
                                        </div>
                                }







                                <div className="form_tab_title">
                                    Odbiorca usługi (jeśli inny):
                                            &nbsp; 
                                            <label className="switch" title="Więcej">                               
                                                <input type="checkbox" checked={checked2}  onChange={handleChange2}/>
                                                <span className="slider round"></span>
                                            </label>  
                                </div>

                                {
                                    checked2 &&
                                        <div className="form_tab">


                                            
                                                    <div className="form_control">
                                                        <div className="fieldName">NIP*</div>
                                                        <InputNIP   userData={props.userData} value={row.odbr_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_nip" placeholder={"NIP:"} className='  ' req='0' firstUp="1" />
                                                    </div>


                                                    <div className="form_control">
                                                        <div className="fieldName">Nazwa*</div>
                                                        <InputText   userData={props.userData} value={row.odbr_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_nazwa" placeholder={"Nazwa:"} className=' w300 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Ulica*</div>
                                                        <InputText   userData={props.userData} value={row.odbr_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_ulica" placeholder={"Ulica:"} className=' w300 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nr domu*</div>
                                                        <InputText   userData={props.userData} value={row.odbr_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nr mieszkania</div>
                                                        <InputText   userData={props.userData} value={row.odbr_nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputPostCode   userData={props.userData} value={row.odbr_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputTextAlpha   userData={props.userData} value={row.odbr_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_miejscowosc" placeholder={"Miasto:"} className=' w200 ' req='0' firstUp="1" />
                                                    </div>

                                                  
                                        </div>
                                }






                                <div className="form_tab_title">
                                    Dodatkowe informacje:                                          
                                </div>

                                 <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Rodzaj kontrahenta*</div>
                                                <InputCombo items={  [ {v:'PL',title:'PL'},  {v:'EU',title:'EU'},   ] }  userData={props.userData} value={row.rodzaj_kontrahenta} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rodzaj_kontrahenta" placeholder={":"} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Domyślne konto do wpłat*</div>
                                                <InputCombo items={ accounts }  userData={props.userData} value={row.sl_rachunki_bankowe_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sl_rachunki_bankowe_id" placeholder={":"} className='  ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Domyślny termin płatności (dni)*</div>
                                                <InputInteger  userData={props.userData} value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci" placeholder={":"} className=' w50 ' req='1' firstUp="0" />
                                            </div>



                                            <div className="form_control">
                                                <div className="fieldName">E-faktura*</div>
                                                <InputCombo items={  [ {v:'1',title:'Tak'},  {v:'0',title:'Nie'},   ] }  userData={props.userData} value={row.e_faktura} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="e_faktura" placeholder={":"} className='  ' req='1' firstUp="0" />
                                            </div>
                                            {
                                                row.e_faktura == 1 &&
                                                <Fragment>
                                                    <div className="form_control">
                                                        <div className="fieldName">E-mail dla e-faktur</div>
                                                        <InputEmail   userData={props.userData} value={row.e_mail_dla_faktur} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="e_mail_dla_faktur" placeholder={"E-mail"} className='   ' req='0' firstUp="0" />
                                                    </div>
                                                </Fragment>
                                            }
                                            


                                          
                                
                                 </div>
                              


                                <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>

                       </form>
    </div>
}


export default ClientForm;